import { MenuItem, Select, SelectProps, styled } from '@mui/material';

import { CerebroDropdownIcon } from './CerebroDropdownIcon';
import { fontFamily, weights } from '../context/CerebroThemeProvider';
import { CerebroText } from '.';

export const CerebroDropdown: React.FC<CerebroDropdownProps> = ({ placeholder, ...props }) => {
	return (
		<StyledDropdown
			IconComponent={CerebroDropdownIcon}
			MenuProps={{
				PaperProps: {
					sx: theme => ({
						backgroundColor: theme.palette.gray.background,
						boxShadow: 'none',
						border: `1px solid ${theme.palette.gray.dark}`,
					}),
				},
			}}
			{...props}
		/>
	);
};

export type CerebroDropdownProps = SelectProps & { placeholder?: string };

export const CerebroDropdownMenuItem = styled(MenuItem)(({ theme }) => ({
	fontFamily,
	fontSize: 12,

	lineHeight: '14px',

	'&.Mui-selected': {
		backgroundColor: theme.palette.primary.main,
	},
}));

const StyledDropdown = styled(Select)(({ error, disabled, readOnly, theme }) => ({
	borderWidth: 2,
	borderStyle: 'solid',
	borderRadius: theme.shape.borderRadius,
	borderColor: error
		? theme.palette.error.main
		: disabled || readOnly
		? theme.palette.gray.light
		: theme.palette.gray.medium,

	color: disabled ? theme.palette.gray.light : theme.palette.gray.dark,

	'&, & *': {
		cursor: disabled ? 'not-allowed' : 'initial',
	},

	'& svg': {
		color: readOnly || disabled ? theme.palette.gray.light : theme.palette.gray.dark,
	},

	fontFamily,
	fontSize: 12,
	fontWeight: disabled ? weights.medium : weights.semibold,

	lineHeight: '14px',

	marginTop: theme.spacing(1.5),
	marginBottom: theme.spacing(1),

	outline: 'none',

	width: '100%',

	'&:focus-within': {
		borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
	},

	'& .MuiSelect-select': {
		padding: '14px 12px',
		minHeight: 'unset !important',
	},

	'& fieldset': {
		border: 'none',
	},
}));
